import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { getStreamStatus } from 'src/utils/leadStreams';

import type { Stream } from 'src/services/LeadStreamsService/agent';

export default function FeedEmptyState({
    streams,
    loading,
    error,
    filtered,
    onRetry,
    onReset,
}: {
    streams: Stream[];
    loading: boolean;
    error: boolean;
    filtered: boolean;
    onRetry: () => void;
    onReset: () => void;
}) {
    const active = streams.find((stream) => getStreamStatus(stream).key === 'active');
    const paused = streams.find((stream) => getStreamStatus(stream).key === 'paused');
    const selected = active || paused || streams[0];
    const title = error
        ? 'Не удалось загрузить лиды'
        : loading
        ? 'Загружаем потоки…'
        : filtered
        ? 'По этим фильтрам лидов нет'
        : active
        ? 'Лидов пока нет'
        : paused
        ? 'Поиск на паузе'
        : streams.length
        ? 'Запустите поток'
        : 'Создайте первый поток';
    const text = error
        ? 'Проверьте соединение и повторите загрузку.'
        : loading
        ? ''
        : filtered
        ? 'Попробуйте другой период или сбросьте фильтры.'
        : active
        ? 'Поиск активен. Новые запросы появятся в этой ленте.'
        : paused
        ? 'Возобновите поток, чтобы получать новые запросы.'
        : streams.length
        ? 'Откройте поток и завершите запуск.'
        : 'Опишите бизнес и выберите, какие запросы получать.';
    return (
        <Box
            role={error ? 'alert' : 'status'}
            sx={{ py: 6, px: 2, textAlign: 'center' }}
        >
            {loading && !error && (
                <CircularProgress
                    size={22}
                    sx={{ mb: 2 }}
                />
            )}
            <Typography fontWeight={600}>{title}</Typography>
            {text && (
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 1, mb: 2 }}
                >
                    {text}
                </Typography>
            )}
            {error ? (
                <Button onClick={onRetry}>Повторить</Button>
            ) : (
                !loading &&
                (filtered ? (
                    <Button onClick={onReset}>Сбросить фильтры</Button>
                ) : (
                    <Button
                        component={Link}
                        to={selected ? '/leadstream/' + selected.id : '/leadstream'}
                        variant={selected ? 'text' : 'contained'}
                    >
                        {active ? 'Открыть поток' : paused ? 'К управлению потоком' : 'Настроить поток'}
                    </Button>
                ))
            )}
        </Box>
    );
}
